import {
    ACCOUNT_PATTERNS,
    DEFAULT_VALUES,
    DOC_NAME_GENERATORS,
} from "../constants";
import { getCurrentDate } from "./calculations";

export const createExpenseJournalEntry = (
    userInfo,
    company,
    amount,
    description,
    expenseAccount
) => {
    const currentDate = getCurrentDate();
    const journalEntryName = DOC_NAME_GENERATORS.JOURNAL_ENTRY();
    const cashAccountName = DOC_NAME_GENERATORS.JOURNAL_ENTRY_ACCOUNT();
    const expenseAccountName = DOC_NAME_GENERATORS.JOURNAL_ENTRY_ACCOUNT();

    return {
        docstatus: 0,
        doctype: "Journal Entry",
        name: journalEntryName,
        __islocal: 1,
        __unsaved: 1,
        owner: userInfo.name,
        naming_series: DEFAULT_VALUES.NAMING_SERIES.JOURNAL_ENTRY,
        company: company.name || company.company_name,
        posting_date: currentDate,
        total_debit: amount,
        total_credit: amount,
        user_remark: description,
        accounts: [
            {
                docstatus: 0,
                doctype: "Journal Entry Account",
                name: cashAccountName,
                __islocal: 1,
                __unsaved: 1,
                owner: userInfo.name,
                parent: journalEntryName,
                parentfield: "accounts",
                parenttype: "Journal Entry",
                idx: 1,
                account:
                    // company.default_cash_account ||
                    ACCOUNT_PATTERNS.CASH(company.abbr),
                debit: 0,
                credit: amount,
                credit_in_account_currency: amount,
            },
            {
                docstatus: 0,
                doctype: "Journal Entry Account",
                name: expenseAccountName,
                __islocal: 1,
                __unsaved: 1,
                owner: userInfo.name,
                parent: journalEntryName,
                parentfield: "accounts",
                parenttype: "Journal Entry",
                idx: 2,
                account: expenseAccount,
                debit: amount,
                debit_in_account_currency: amount,
                credit: 0,
            },
        ],
    };
};
